module.exports = __webpack_public_path__ + "img/logo_min.c284d9f9.png";